import React, { useState } from "react";
import clsx from "clsx";
import _orderBy from "lodash/orderBy";
import moment from "moment";
import { Paper, Table, TableBody, TableCell, TablePagination, TableRow } from "@material-ui/core";
import OrdersTableHead from "./OrdersTableHead";
import OrderPanel from "./OrderPanel";
import useStyles from "./styles";

const OrdersTable = ({ orders }) => {
  const classes = useStyles();
  // eslint-disable-next-line
  const [data, setData] = useState(orders); //used for Search
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [order, setOrder] = useState({
    direction: "desc",
    id: "completed_at"
  });
  const [orderDetail, setOrderDetail] = useState(data[0]);
  const [isOpen, setIsOpen] = useState(false);
  const togglePanel = () => setIsOpen(!isOpen);

  const handleSort = (event, property) => {
    const id = property;
    let direction = "desc";

    if (order.id === property && order.direction === "desc") {
      direction = "asc";
    }

    setOrder({
      direction,
      id
    });
  };

  const handleChangePage = (event, page) => {
    setPage(page);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(event.target.value);
  };

  const handleClick = (event, order) => {
    setOrderDetail(order);
    togglePanel();
  };

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <Table>
          <OrdersTableHead onSort={handleSort} order={order} />
          <TableBody>
            {_orderBy(
              data,
              o => {
                switch (order.id) {
                  case "tender_type":
                    return o.tender_type;
                  case "created_at":
                    return o.created_at;
                  case "summary":
                    return o.summary;
                  case "category":
                    return o.category;
                  default:
                    return o.completed_at;
                }
              },
              [order.direction]
            )
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map(n => {
                return (
                  <TableRow className={clsx(classes.defaultHeight, classes.pointer)} tabIndex={-1} key={n.id} hover onClick={event => handleClick(event, n)}>
                    <TableCell component="th" scope="row">
                      {moment(n.created_at).format("LTS")}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {n.tender_type}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {n.summary}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {n.category}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {moment(n.completed_at).format("LTS")}
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={data.length}
          rowsPerPage={rowsPerPage}
          page={page}
          backIconButtonProps={{
            "aria-label": "Previous Page"
          }}
          nextIconButtonProps={{
            "aria-label": "Next Page"
          }}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
      {orderDetail ? <OrderPanel order={orderDetail} isOpen={isOpen} togglePanel={togglePanel} /> : null}
    </div>
  );
};

export default OrdersTable;
